import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  ACCEPT_RETURN,
  CHANGE_STATUS_OF_ORDER,
  GET_RETURN_SHIPMENT,
  ORDER_STATUS_BAR,
  RETURN_BY_REF,
  RETURN_LISTING,
} from "../../utils/queries";
import { createGraphQLThunk } from ".";

export const ReturnThunk = createAsyncThunk(
  "ReturnSlice/ReturnThunk",
  createGraphQLThunk({
    query: RETURN_LISTING,
    getVariables: ({ orderRequestFilters }) => ({ orderRequestFilters }),
    responseKey: "getCategorizedReturnOrders",
  })
);

export const ReturnDetailThunk = createAsyncThunk(
  "ReturnSlice/ReturnDetailThunk",
  createGraphQLThunk({
    query: RETURN_BY_REF,
    getVariables: ({ orderRefId }) => ({ orderRefId }),
    responseKey: "getReturnByRef",
  })
);

export const ReturnBarThunk = createAsyncThunk(
  "ReturnBarSlice/ReturnBarThunk",
  createGraphQLThunk({
    query: ORDER_STATUS_BAR,
    getVariables: ({ orderRefId }) => ({ orderRefId }),
    responseKey: "getOrderStatusBar",
  })
);

export const ReturnShipmentThunk = createAsyncThunk(
  "ReturnShipmentSlice/ReturnShipmentThunk",
  createGraphQLThunk({
    query: GET_RETURN_SHIPMENT,
    getVariables: ({ orderRefId }) => ({ orderRefId }),
    responseKey: "getReturnShipment",
  })
);

export const ReturnChangeStatusThunk = createAsyncThunk(
  "ReturnShipmentSlice/ReturnChangeStatusThunk",
  createGraphQLThunk({
    query: CHANGE_STATUS_OF_ORDER,
    getVariables: ({ orderStatusChangeRequest }) => ({
      orderStatusChangeRequest,
    }),
    responseKey: "changeStatusOfOrder",
    onSuccessMessage: "Status Changed",
  })
);

export const ReturnAcceptThunk = createAsyncThunk(
  "ReturnShipmentSlice/ReturnAcceptThunk",
  createGraphQLThunk({
    query: ACCEPT_RETURN,
    getVariables: ({ approveOrderRequest }) => ({ approveOrderRequest }),
    responseKey: "acceptReturn",
    onSuccessMessage: "Return Accepted",
  })
);
